import {
    TerminalLogItem
  } from "../../app/data/terminal-details/models";
  
  
  export const initialTerminalChangelogState: TerminalChangelogState = {
    requestStarted: false,
    fetchPortionStarted: false,
    requestCreator: "",
    requestSucceed: false,
    requestFailed: false,
    requestFailStatus: 0,
    requestError: "",
    terminalLog: [],
    terminalLogRequest: {
      page: 0,
      last: false
    }
  };
  export default interface TerminalChangelogState {
    requestStarted: boolean;
    fetchPortionStarted: boolean;
    requestCreator: string;
    requestSucceed: boolean;
    requestFailed: boolean;
    requestFailStatus: number;
    requestError: string;
    terminalLog: TerminalLogItem[];
    terminalLogRequest: {
      page: number;
      last: boolean;
    };
  }
  